export default  {
  require: {
    ngModel: 'ngModel'
  },
  controller: 'propertiesSelectController',
  template: require('../views/properties.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/properties.select.component.js